import { jwtDecode } from 'jwt-decode';
import { userServices } from 'src/services/auth/user/user.service';

const keysInLocalStorage = (keys) => {
  let keysEmpty = []
  keys.forEach((key) => {
    if (localStorage.getItem(key) === null) {
      keysEmpty.push(key)
    }
  })
  if (keysEmpty.length === 0) {
    return true
  }
  return false
}


const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000; // Tiempo actual en segundos
    return decoded < now;
  } catch (error) {
    return true; // asumir que el token ha expirado si ocurre algún error al decodificar
  }
};

const AuthProvider =  {
  login: async ({clients, /* username, password, application_id, user_id, device_code, */ client_id,visitorId }) => {
    try {
      /* let URL = `${process.env.REACT_APP_URL_AUTH}/login-web`
      const body = {
        user: username,
        pass: password,
        ...(device_code && { device_code })
      }


      const request = new Request(URL, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: new Headers({
          'Content-Type': 'application/json',
          ...(visitorId && { 'Visitor-Id': visitorId }),
        }),
      })
      const response = await fetch(request)
      const loginResponse = await response.json() */
      
      /* const clients = loginResponse.clients */
      let selected_client = null
      if(client_id){
        selected_client = clients.find(cli=>cli.client_id === client_id)
      } else {
        selected_client = clients[0]
      }
      const tokenResponse = await userServices.loginByToken(selected_client.jwt)
      if (!tokenResponse.user.is_staff) {
        throw new Error('ra.auth.sign_in_error')
      }
      const data_complete = {
        user:tokenResponse.user, 
        application:tokenResponse.application, 
        jwt:selected_client.jwt,
        roles:tokenResponse.roles,
        dashboard:tokenResponse.dashboard,
        client_id:tokenResponse.client_id,
        hash_client:selected_client.client.hash_client
      }

      data_complete.application.modules.forEach((module) => {
        const permissions = []
        module.permission.forEach((permission) => {
          if (!permissions.find((elem) => elem.entity_id === permission.entity_id)) {
            permissions.push(permission)
          }
        })
        module.permission = permissions
      })
      localStorage.setItem('jwt', data_complete.jwt)
      localStorage.setItem('hash_user', data_complete.user.hashuser)
      localStorage.setItem('language', data_complete.user.language || 'es-AR')
      localStorage.setItem('application', JSON.stringify(data_complete.application))
      localStorage.setItem(
        'user',
        JSON.stringify({
          ...data_complete.user,
          roles: data_complete.roles,
          dashboard: data_complete?.dashboard,
          user_id: selected_client?.user_id,
          client_id: data_complete?.client_id,
          visitor_id: visitorId,
        })
      )
      localStorage.setItem('clients', JSON.stringify(clients.map(cli=>{
        return {client_id:cli.client_id,name:cli.client.long_name, jwt:cli.jwt, hash_client:cli.client.hash_client, application:tokenResponse.application.name}
      })))
      // Emitir evento de cambio de idioma
      let event = new Event('languageChanged')
      window.dispatchEvent(event)
    } catch (error) {
      throw new Error(error?.message || 'El usuario y/o contraseña es incorrecto')
    }
  },
  // login: async ({ username, password }) => {
  //   let URL = `${process.env.REACT_APP_URL_RESERVATION}/login/login`
  //   const request = new Request(URL, {
  //     method: 'POST',
  //     body: JSON.stringify({ user: username, password }),
  //     headers: new Headers({ 'Content-Type': 'application/json' }),
  //   })
  //   try {
  //     const response = await fetch(request)
  //     if (response.status < 200 || response.status >= 300) {
  //       throw new Error(response.statusText)
  //     }
  //     const data = await response.json()

  //     if (!data.user.is_staff) {
  //       throw new Error('El usuario no posee los permisos necesarios para acceder')
  //     }

  //     data.application.modules.forEach((module) => {
  //       const permissions = []
  //       module.permission.forEach((permission) => {
  //         if (!permissions.find((elem) => elem.entity_id === permission.entity_id)) {
  //           permissions.push(permission)
  //         }
  //       })
  //       module.permission = permissions
  //     })

  //     localStorage.setItem('jwt', data.jwt)
  //     localStorage.setItem('hash_user', data.user.hashuser)
  //     localStorage.setItem('application', JSON.stringify(data.application))
  //     localStorage.setItem('user', JSON.stringify(data.user))
  //   } catch (error) {
  //     throw new Error(error?.message || 'El usuario y/o contraseña es incorrecto')
  //   }
  // },

  // called when the user clicks on the logout button
  logout: () => {
    localStorage.clear()
    return Promise.resolve()
  },

  // called when the API returns an error
  checkError: ({ status, message }) => {
    if (status === 401) {
      return Promise.reject({ redirectTo: '/', logoutUser: false, message: 'ra.auth.unauthorized' }) //react-admin passes the error message to the translation layer
    }
    if (status === 403) {
      return Promise.reject({ message: 'ra.auth.forbidden' })
    }
    return Promise.resolve()
  },

  // called when the user navigates to a new location, to check for authentication
  checkAuth: async () => {
    let keys = ['jwt', 'user', 'application', 'hash_user']
    if (!keysInLocalStorage(keys)) {
      return Promise.reject({ message: 'ra.auth.forbidden' })
    }
    let URL = `${process.env.REACT_APP_URL_AUTH}/authenticate_token`
    const request = new Request(URL, {
      method: 'POST',
      body: JSON.stringify({ token: localStorage.getItem('jwt') }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    try {
      const response = await fetch(request)
      if (response.status === 401) {
        return Promise.reject({ message: 'ra.auth.forbidden' })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject({ message: 'ra.auth.forbidden' })
    }
  },

  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => {
    let keys = ['jwt', 'user', 'application', 'hash_user']
    const token = localStorage.getItem('jwt')
    if (keysInLocalStorage(keys) && !isTokenExpired(token)) {
      const applicationData = JSON.parse(localStorage.getItem('application'))
      if (applicationData && 'modules' in applicationData) {
        return Promise.resolve({ modules: applicationData.modules })
      }
    }
    localStorage.clear()
    return Promise.reject({ message: 'ra.auth.forbidden' })
  },

  getIdentity: () => {
    try {
      const language = localStorage.getItem('language')
      const {
        hashuser,
        name,
        surname,
        dashboard,
        email,
        client_id,
        is_superadmin,
        is_admin,
        user_id,
        visitor_id,
      } = JSON.parse(localStorage.getItem('user'))
      const fullName = name + ' ' + surname
      const theme = 'black'
      return Promise.resolve({
        id: hashuser,
        fullName,
        theme,
        dashboard: dashboard,
        email,
        client_id,
        is_superadmin,
        is_admin,
        language,
        user_id,
        visitor_id,
      })
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default AuthProvider
